import {
  type WorkerPaymentIncludedShift,
  type WorkerPaymentIncludedWorkplace,
  workerPaymentsContract,
  type WorkerPaymentsResponse,
} from "@clipboard-health/contract-worker-app-bff";
import { get } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { useInfiniteQuery, type UseInfiniteQueryResult } from "@tanstack/react-query";
import { type AxiosError } from "axios";

export type PaymentsItemPayment = WorkerPaymentsResponse["data"][number];

export type PaymentsItemWorkplace = WorkerPaymentIncludedWorkplace;

export type PaymentsItemShift = WorkerPaymentIncludedShift;

export function useGetWorkerPayments(options?: {
  enabled: boolean;
}): UseInfiniteQueryResult<WorkerPaymentsResponse, AxiosError> {
  const worker = useDefinedWorker();

  return useInfiniteQuery({
    enabled: options?.enabled,
    queryKey: ["get-worker-payments", worker.userId],
    queryFn: async ({ pageParam: pageParameter }) => {
      const cursor = pageParameter as string | undefined;

      const result = await get({
        url: `${environmentConfig.REACT_APP_WORKER_APP_BFF_URL}/worker-payments`,
        queryParams: {
          "page[cursor]": cursor,
        },
        responseSchema: workerPaymentsContract.list.responses[200],
      });

      return result.data;
    },
    getNextPageParam: (response) => {
      return response.meta.page.nextCursor;
    },
    meta: {
      userErrorMessage: "Failed to load payments",
    },
  });
}
